// User context - now uses real Azure AD authentication
import React, { createContext, useContext, ReactNode } from 'react';
import { useAuth } from './AuthContext';

interface UserContextType {
  currentRole: string;
  setCurrentRole: (role: string) => void;
  isEmployee: boolean;
  isManager: boolean;
  isAdmin: boolean;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { user, hasRole } = useAuth();

  // For now, show all roles (mock behavior for testing)
  // TODO: When Graph API integration is complete, this will use real roles from Azure AD groups
  const currentRole = 'Employee'; // Default role

  const value: UserContextType = {
    currentRole,
    setCurrentRole: () => {}, // No-op for now, roles come from Azure AD
    isEmployee: hasRole('Employee'),
    isManager: hasRole('Manager'),
    isAdmin: hasRole('Admin'),
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within UserProvider');
  }
  return context;
};